import { alertUser } from '@actions/alerts';
import { UserSession } from '@app/types';
import { ActionCopyIcon, EmailIcon, MessagesIcon } from '@components/Icons';
import { Dispatch } from 'redux';
import analytics from '@support/analytics';
import emailURL from './preferred-email-client';

const userReferralMsg = (user: UserSession) => {
  let link = `https://clay.earth/invite/${user?.username}`;
  if (!user?.username) {
    link = 'https://clay.earth';
  }
  return `I think you'll get a lot of value from Clay and wanted to invite you to sign up. Here's my invitation link to learn more 🙂 ${link}`;
};

export const copyReferralToClipboard = (user: UserSession, dispatch: Dispatch) => {
  navigator.clipboard.writeText(userReferralMsg(user));
  dispatch(alertUser('Invite copied to clipboard', 'success'));
};

export const trackReferral = () => analytics.track('Invite to Clay Tapped');

export const buildReferralActions = (
  user: UserSession,
  dispatch: Dispatch,
  onSelect?: () => void,
) => {
  const referralMsg = userReferralMsg(user);
  return [
    {
      title: 'Email',
      action: () => {
        window.location.href = emailURL({
          subject: 'An invitation to join Clay',
          body: referralMsg,
        });
        onSelect?.();
      },

      icon: EmailIcon,
    },
    {
      title: 'Message',
      action: () => {
        window.location.href = `sms:&body=${referralMsg}`;
        onSelect?.();
      },
      icon: MessagesIcon,
    },
    {
      title: 'Copy to Clipboard',
      action: () => {
        copyReferralToClipboard(user, dispatch);
        onSelect?.();
      },
      icon: ActionCopyIcon,
    },
  ];
};
